import { render, staticRenderFns } from "./UsersBalance.vue?vue&type=template&id=0c8bb7c8&scoped=true&"
import script from "./UsersBalance.vue?vue&type=script&lang=js&"
export * from "./UsersBalance.vue?vue&type=script&lang=js&"
import style0 from "./UsersBalance.vue?vue&type=style&index=0&id=0c8bb7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8bb7c8",
  null
  
)

export default component.exports